import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Modal, Paragraph, Popover, Spinner } from '@treams/treams-ui';

export default function EvaluationSubmissionShareModal(props: {
	submission: graphql.EvaluationSubmission;
	sharing: boolean;
	onDismiss: () => void;
	onShare: () => void;
}) {
	const { t } = useTranslation();

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header title={t('evaluation.submission.share.modal.title')} />
				<Modal.Contents>
					<Paragraph>{t('evaluation.submission.share.modal.description')}</Paragraph>
				</Modal.Contents>

				{props.sharing ? (
					<Spinner centered />
				) : (
					<Modal.FormFooter
						saveTitle={t('evaluation.submission.share.modal.confirm')}
						onCancel={props.onDismiss}
						onSave={() => {
							props.onShare();
							props.onDismiss();
						}}
					/>
				)}
			</Modal>
		</Popover>
	);
}
